export const HKDSE_MATHS_MC_2016 = {
    year: 2016,
    title: "HKDSE 數學科 多項選擇題 2016 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2016Q001",
        questionNumber: 1,
        question: "$8^{222} \\cdot 5^{666} =$",
        options: [
          { id: "A", text: "$10^{666}$" },
          { id: "B", text: "$10^{888}$" },
          { id: "C", text: "$40^{666}$" },
          { id: "D", text: "$40^{888}$" }
        ],
        correctAnswer: "B",
        solution: "$8^{222} \\cdot 5^{666} = (2^3)^{222} \\cdot 5^{666} = 2^{666} \\cdot 5^{666} = (2 \\cdot 5)^{666} = 10^{666}$",
        topic: "指數",
        difficulty: "基礎"
      },
      {
        id: "2016Q002",
        questionNumber: 2,
        question: "若 $\\frac{a}{x} + \\frac{b}{y} = 3$，則 $x =$",
        options: [
          { id: "A", text: "$\\frac{ay}{3y-b}$" },
          { id: "B", text: "$\\frac{ay}{b-3y}$" },
          { id: "C", text: "$\\frac{by}{3y-a}$" },
          { id: "D", text: "$\\frac{by}{a-3y}$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{a}{x} + \\frac{b}{y} = 3$\\n$\\frac{a}{x} = 3 - \\frac{b}{y}$\\n$\\frac{a}{x} = \\frac{3y-b}{y}$\\n$x = \\frac{ay}{3y-b}$",
        topic: "分式方程",
        difficulty: "基礎"
      },
      {
        id: "2016Q003",
        questionNumber: 3,
        question: "$16-(2x-3y)^2 =$",
        options: [
          { id: "A", text: "$(4-2x-3y)(4+2x+3y)$" },
          { id: "B", text: "$(4-2x-3y)(4+2x-3y)$" },
          { id: "C", text: "$(4-2x+3y)(4+2x+3y)$" },
          { id: "D", text: "$(4-2x+3y)(4+2x-3y)$" }
        ],
        correctAnswer: "D",
        solution: "$16-(2x-3y)^2 = 4^2-(2x-3y)^2 = (4-(2x-3y))(4+(2x-3y)) = (4-2x+3y)(4+2x-3y)$",
        topic: "因式分解",
        difficulty: "基礎"
      },
      {
        id: "2016Q004",
        questionNumber: 4,
        question: "$0.765403 =$",
        options: [
          { id: "A", text: "$0.076$ (準確至二位有效數字)" },
          { id: "B", text: "$0.0765$ (準確至三位小數)" },
          { id: "C", text: "$0.07654$ (準確至四位有效數字)" },
          { id: "D", text: "$0.076540$ (準確至五位小數)" }
        ],
        correctAnswer: "C",
        solution: "$0.765403$ 準確至四位有效數字為 $0.7654$",
        topic: "近似值",
        difficulty: "基礎"
      },
      {
        id: "2016Q005",
        questionNumber: 5,
        question: "若 $4\\alpha + \\beta = 7\\alpha + 3\\beta = 5$，則 $\\beta =$",
        options: [
          { id: "A", text: "$-3$" },
          { id: "B", text: "$-2$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$3$" }
        ],
        correctAnswer: "A",
        solution: "$4\\alpha + \\beta = 5$\\n$7\\alpha + 3\\beta = 5$\\n$12\\alpha + 3\\beta = 15$（第一式乘以3）\\n$7\\alpha + 3\\beta = 5$\\n相減：$5\\alpha = 10$\\n$\\alpha = 2$\\n$4(2) + \\beta = 5$\\n$\\beta = -3$",
        topic: "聯立方程",
        difficulty: "中等"
      },
      {
        id: "2016Q006",
        questionNumber: 6,
        question: "設 $f(x) = 4x^3 + kx + 3$，其中 $k$ 為一常數。若 $f(x)$ 可被 $2x+1$ 整除，求當 $f(x)$ 除以 $x+1$ 時的餘數。",
        options: [
          { id: "A", text: "$-7$" },
          { id: "B", text: "$-6$" },
          { id: "C", text: "$0$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "A",
        solution: "$f(-\\frac{1}{2}) = 0$（因可被 $2x+1$ 整除）\\n$4(-\\frac{1}{2})^3 + k(-\\frac{1}{2}) + 3 = 0$\\n$-\\frac{1}{2} - \\frac{k}{2} + 3 = 0$\\n$k = 5$\\n$f(-1) = 4(-1)^3 + 5(-1) + 3 = -4 - 5 + 3 = -6$",
        topic: "多項式",
        difficulty: "中等"
      },
      {
        id: "2016Q007",
        questionNumber: 7,
        question: "$-5x > 21-2x$ 及 $6x-18 < 0$ 的解為",
        options: [
          { id: "A", text: "$x < -7$" },
          { id: "B", text: "$x < 3$" },
          { id: "C", text: "$-7 < x < 3$" },
          { id: "D", text: "$x < -7$ 或 $x > 3$" }
        ],
        correctAnswer: "A",
        solution: "$-5x > 21-2x$ 得 $-3x > 21$，即 $x < -7$\\n$6x-18 < 0$ 得 $6x < 18$，即 $x < 3$\\n取交集：$x < -7$",
        topic: "不等式",
        difficulty: "基礎"
      },
      {
        id: "2016Q008",
        questionNumber: 8,
        question: "若 $k$ 為一常數使得二次方程 $x^2 + kx + 8k + 36 = 0$ 有等根，則 $k =$",
        options: [
          { id: "A", text: "$-6$" },
          { id: "B", text: "$12$" },
          { id: "C", text: "$-4$ 或 $36$" },
          { id: "D", text: "$-18$ 或 $2$" }
        ],
        correctAnswer: "D",
        solution: "判別式 $= k^2 - 4(8k + 36) = k^2 - 32k - 144 = 0$\\n$(k + 4)(k - 36) = 0$\\n$k = -4$ 或 $k = 36$",
        topic: "二次方程",
        difficulty: "中等"
      },
      {
        id: "2016Q009",
        questionNumber: 9,
        question: "若 $-1 < a < 0$，則下列何者可表示 $y = (ax+1)^2 + a$ 的圖像？",
        options: [
          { id: "A", text: "選項 A 的圖像" },
          { id: "B", text: "選項 B 的圖像" },
          { id: "C", text: "選項 C 的圖像" },
          { id: "D", text: "選項 D 的圖像" }
        ],
        correctAnswer: "B",
        solution: "$y = (ax+1)^2 + a = a^2x^2 + 2ax + 1 + a$\\n$a < 0$，所以開口向下\\n頂點在 $x$ 軸下方（因為 $a < 0$）",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2016Q010",
        questionNumber: 10,
        question: "達林的月薪較文俊高 $25%$，而文俊的月薪較佩怡低 $25%$。已知達林的月薪為 $$33360$。佩怡的月薪為",
        options: [
          { id: "A", text: "$$31275$" },
          { id: "B", text: "$$33360$" },
          { id: "C", text: "$$35584$" },
          { id: "D", text: "$$52125$" }
        ],
        correctAnswer: "C",
        solution: "設佩怡的月薪為 $x$\\n文俊的月薪 $= 0.75x$\\n達林的月薪 $= 1.25(0.75x) = 0.9375x = 33360$\\n$x = \\frac{33360}{0.9375} = 35584$",
        topic: "百分比",
        difficulty: "中等"
      },
      {
        id: "2016Q011",
        questionNumber: 11,
        question: "若 $x$ 及 $y$ 均為非零的數使得 $(3y-4x):(2x+y) = 5:6$，則 $x:y =$",
        options: [
          { id: "A", text: "$7:8$" },
          { id: "B", text: "$8:29$" },
          { id: "C", text: "$9:32$" },
          { id: "D", text: "$13:34$" }
        ],
        correctAnswer: "B",
        solution: "$\\frac{3y-4x}{2x+y} = \\frac{5}{6}$\\n$6(3y-4x) = 5(2x+y)$\\n$18y-24x = 10x+5y$\\n$13y = 34x$\\n$\\frac{x}{y} = \\frac{13}{34}$\\n$x:y = 13:34$",
        topic: "比例",
        difficulty: "中等"
      },
      {
        id: "2016Q012",
        questionNumber: 12,
        question: "已知 $z$ 隨 $\\sqrt{x}$ 正變且隨 $y$ 反變。若 $x$ 減少 $36%$ 且 $y$ 增加 $60%$，則 $z$",
        options: [
          { id: "A", text: "增加 $24%$" },
          { id: "B", text: "增加 $28%$" },
          { id: "C", text: "減少 $40%$" },
          { id: "D", text: "減少 $50%$" }
        ],
        correctAnswer: "D",
        solution: "$z = k\\frac{\\sqrt{x}}{y}$\\n$x$ 減少 $36%$，即 $x$ 變為 $0.64x$\\n$y$ 增加 $60%$，即 $y$ 變為 $1.6y$\\n新值 $= k\\frac{\\sqrt{0.64x}}{1.6y} = k\\frac{0.8\\sqrt{x}}{1.6y} = 0.5k\\frac{\\sqrt{x}}{y} = 0.5z$\\n因此 $z$ 減少 $50%$",
        topic: "變分",
        difficulty: "困難"
      },
      {
        id: "2016Q013",
        questionNumber: 13,
        question: "$X$ 牌麵粉的成本為 $$42$/kg$。若 $3$kg 的 $X$ 牌麵粉與 $2$kg 的 $Y$ 牌麵粉混合使得混合後的麵粉的成本為 $$36$/kg$，求 $Y$ 牌麵粉的成本。",
        options: [
          { id: "A", text: "$$27$/kg$" },
          { id: "B", text: "$$30$/kg$" },
          { id: "C", text: "$$32$/kg$" },
          { id: "D", text: "$$39$/kg$" }
        ],
        correctAnswer: "A",
        solution: "設 $Y$ 牌麵粉的成本為 $x$ 元/kg\\n$3 \\times 42 + 2 \\times x = 5 \\times 36$\\n$126 + 2x = 180$\\n$2x = 54$\\n$x = 27$",
        topic: "混合問題",
        difficulty: "中等"
      },
      {
        id: "2016Q014",
        questionNumber: 14,
        question: "圖中，第 $1$ 個圖案包含 $9$ 粒點子。對任意正整數 $n$，第 $(n+1)$ 個圖案是由第 $n$ 個圖案加上 $5$ 粒點子所組成。求第 $7$ 個圖案的點子數目。",
        options: [
          { id: "A", text: "$29$" },
          { id: "B", text: "$34$" },
          { id: "C", text: "$39$" },
          { id: "D", text: "$44$" }
        ],
        correctAnswer: "C",
        solution: "第 $n$ 個圖案的點子數目 $= 9 + 5(n-1) = 5n + 4$\\n第 $7$ 個圖案：$5(7) + 4 = 39$",
        topic: "數列",
        difficulty: "基礎"
      },
      {
        id: "2016Q015",
        questionNumber: 15,
        question: "根據圖中所示，下列何者必為正確？\\nI. $a + c = 180°$\\nII. $a + b - c = 180°$\\nIII. $b + c = 360°$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "兩直線相交，對頂角相等\\n$a + c = 180°$（直線上的角）\\n$b + c = 360°$（周角）",
        topic: "角度",
        difficulty: "基礎"
      },
      {
        id: "2016Q016",
        questionNumber: 16,
        question: "圖中，$ABC$ 為一直線。若 $AB = 24$cm、$AD = 40$cm、$BD = 32$cm 及 $CD = 68$cm，則 $BC =$",
        options: [
          { id: "A", text: "$43$cm" },
          { id: "B", text: "$54$cm" },
          { id: "C", text: "$55$cm" },
          { id: "D", text: "$60$cm" }
        ],
        correctAnswer: "C",
        solution: "$BC = BD + CD = 32 + 68 = 100$cm\\n但 $ABC$ 為一直線，所以 $BC = 100 - 24 = 76$cm",
        topic: "長度",
        difficulty: "中等"
      },
      {
        id: "2016Q017",
        questionNumber: 17,
        question: "圖中，$ABCD$ 為一平行四邊形。$E$ 為 $CD$ 上的一點使得 $BE = CE$。若 $\\angle ADC = 114°$，則 $\\angle ABE =$",
        options: [
          { id: "A", text: "$48°$" },
          { id: "B", text: "$57°$" },
          { id: "C", text: "$62°$" },
          { id: "D", text: "$66°$" }
        ],
        correctAnswer: "B",
        solution: "$BE = CE$，所以 $\\triangle BCE$ 為等腰三角形\\n$\\angle CBE = \\angle BCE = \\frac{180° - 114°}{2} = 33°$\\n$\\angle ABE = 180° - 114° - 33° = 33°$",
        topic: "幾何",
        difficulty: "中等"
      },
      {
        id: "2016Q018",
        questionNumber: 18,
        question: "圖中所示為一直立角柱體。求該角柱體的體積。",
        options: [
          { id: "A", text: "$216$cm$^3$" },
          { id: "B", text: "$240$cm$^3$" },
          { id: "C", text: "$300$cm$^3$" },
          { id: "D", text: "$328$cm$^3$" }
        ],
        correctAnswer: "C",
        solution: "底面積 $= 6 \\times 4 = 24$ cm$^2$\\n高 $= 5$ cm\\n體積 $= 24 \\times 5 = 120$ cm$^3$",
        topic: "立體幾何",
        difficulty: "基礎"
      },
      {
        id: "2016Q019",
        questionNumber: 19,
        question: "圖中，扇形 $OAB$ 及扇形 $OCD$ 的圓心均為 $O$，其中 $OA = 33$cm 及 $OC = 39$cm。陰影區域 $ABDC$ 的面積為 $72\\pi$ cm$^2$。下列何者正確？\\nI. 扇形 $OAB$ 的角為 $60°$\\nII. 扇形 $OAB$ 的面積為 $11\\pi$ cm$^2$\\nIII. 扇形 $OCD$ 的周界為 $13\\pi$ cm",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "D",
        solution: "陰影面積 $= \\frac{1}{2}(39^2 - 33^2)\\theta = 72\\pi$\\n$\\frac{1}{2}(1521 - 1089)\\theta = 72\\pi$\\n$216\\theta = 144\\pi$\\n$\\theta = \\frac{2\\pi}{3} = 120°$",
        topic: "扇形面積",
        difficulty: "困難"
      },
      {
        id: "2016Q020",
        questionNumber: 20,
        question: "圖中，$ABCD$、$CDEF$ 及 $EFGH$ 均為正方形。$AG$ 分別與 $CD$ 及 $EF$ 相交於 $P$ 及 $Q$。求四邊形 $DEQP$ 的面積與四邊形 $ABCP$ 的面積之比。",
        options: [
          { id: "A", text: "$1:2$" },
          { id: "B", text: "$2:3$" },
          { id: "C", text: "$3:5$" },
          { id: "D", text: "$4:9$" }
        ],
        correctAnswer: "C",
        solution: "設正方形邊長為 $1$\\n$ABCP$ 的面積 $= \\frac{1}{2} \\times 1 \\times 1 = \\frac{1}{2}$\\n$DEQP$ 的面積 $= \\frac{1}{2} \\times 1 \\times \\frac{3}{5} = \\frac{3}{10}$\\n面積比 $= \\frac{3}{10} : \\frac{1}{2} = 3:5$",
        topic: "面積",
        difficulty: "困難"
      },
      {
        id: "2016Q021",
        questionNumber: 21,
        question: "圖中，$AD =$",
        options: [
          { id: "A", text: "$AB\\cos a + BC\\cos c$" },
          { id: "B", text: "$AB\\cos a + BC\\sin c$" },
          { id: "C", text: "$AB\\sin a + BC\\cos c$" },
          { id: "D", text: "$AB\\sin a + BC\\sin c$" }
        ],
        correctAnswer: "A",
        solution: "$AD = AB\\cos a + BC\\cos c$（投影）",
        topic: "三角學",
        difficulty: "中等"
      },
      {
        id: "2016Q022",
        questionNumber: 22,
        question: "圖中，$ABCD$ 為一菱形。$C$ 為圓 $BDE$ 的圓心且 $ADE$ 為一直線。$BE$ 與 $CD$ 相交於 $F$。若 $\\angle ADC = 118°$，則 $\\angle DFE =$",
        options: [
          { id: "A", text: "$59°$" },
          { id: "B", text: "$62°$" },
          { id: "C", text: "$78°$" },
          { id: "D", text: "$87°$" }
        ],
        correctAnswer: "B",
        solution: "$\\angle ADC = 118°$\\n$\\angle BCD = 118°$（菱形對角相等）\\n$\\angle DFE = 180° - 118° - 62° = 62°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2016Q023",
        questionNumber: 23,
        question: "下面的圖形包含八個完全相同的正六邊形。該圖形的反射對稱軸的數目為",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$4$" },
          { id: "C", text: "$6$" },
          { id: "D", text: "$8$" }
        ],
        correctAnswer: "C",
        solution: "八個正六邊形組成的圖形有 $6$ 條反射對稱軸",
        topic: "對稱",
        difficulty: "中等"
      },
      {
        id: "2016Q024",
        questionNumber: 24,
        question: "若一正 $n$ 邊形的內角和為 $3240°$，則下列何者正確？",
        options: [
          { id: "A", text: "$n$ 的值為 $16$" },
          { id: "B", text: "該多邊形的每一外角均為 $18°$" },
          { id: "C", text: "該多邊形的對角線數目為 $20$" },
          { id: "D", text: "該多邊形的每一內角均為 $160°$" }
        ],
        correctAnswer: "B",
        solution: "內角和 $= (n-2) \\times 180° = 3240°$\\n$n-2 = 18$\\n$n = 20$\\n外角 $= \\frac{360°}{20} = 18°$",
        topic: "多邊形",
        difficulty: "中等"
      },
      {
        id: "2016Q025",
        questionNumber: 25,
        question: "若直線 $hx + ky + 15 = 0$ 與直線 $4x + 3y - 5 = 0$ 互相垂直且相交於 $x$ 軸上的一點，則 $k =$",
        options: [
          { id: "A", text: "$-12$" },
          { id: "B", text: "$-4$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$16$" }
        ],
        correctAnswer: "D",
        solution: "兩直線垂直：$h \\times 4 + k \\times 3 = 0$\\n$4h + 3k = 0$\\n交點在 $x$ 軸上：$y = 0$\\n$4x - 5 = 0$，$x = \\frac{5}{4}$\\n$h(\\frac{5}{4}) + 15 = 0$\\n$h = -12$\\n$4(-12) + 3k = 0$\\n$k = 16$",
        topic: "直線方程",
        difficulty: "困難"
      },
     {
        id: "2016Q026",
        questionNumber: 26,
        question: "點 $A$ 及點 $B$ 的坐標分別為 $(9, -2)$ 及 $(-1, 8)$。若 $C$ 為直線 $x - 2y = 0$ 上的一點使得 $AC = BC$，則 $C$ 的 $x$ 坐標為",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$4$" }
        ],
        correctAnswer: "C",
        solution: "$C$ 在 $x - 2y = 0$ 上，所以 $C$ 的坐標為 $(x, \\frac{x}{2})$\\n$AC = BC$\\n$(x-9)^2 + (\\frac{x}{2}+2)^2 = (x+1)^2 + (\\frac{x}{2}-8)^2$\\n解得 $x = 3$",
        topic: "坐標幾何",
        difficulty: "中等"
      },
      {
        id: "2016Q027",
        questionNumber: 27,
        question: "圓 $C$ 的方程為 $3x^2 + 3y^2 - 12x + 30y + 65 = 0$。下列何者正確？\\nI. $C$ 的半徑為 $14$\\nII. 原點位於 $C$ 以外\\nIII. $C$ 的圓心的坐標為 $(2, -5)$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "C",
        solution: "$3x^2 + 3y^2 - 12x + 30y + 65 = 0$\\n$x^2 + y^2 - 4x + 10y + \\frac{65}{3} = 0$\\n圓心 $(2, -5)$\\n半徑 $= \\sqrt{4 + 25 - \\frac{65}{3}} = \\sqrt{\\frac{22}{3}}$",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2016Q028",
        questionNumber: 28,
        question: "潔儀的口袋內有一個 $$1$ 硬幣、一個 $$2$ 硬幣、一個 $$5$ 硬幣及一個 $$10$ 硬幣。若潔儀從她的口袋中隨機取出三個硬幣，求她取得至少 $$13$ 的概率。",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{1}{4}$" },
          { id: "C", text: "$\\frac{3}{4}$" },
          { id: "D", text: "$\\frac{23}{24}$" }
        ],
        correctAnswer: "B",
        solution: "總組合數 $= C_3^4 = 4$\\n取得至少 $$13$ 的組合：$(1,2,10)$ 和 $(1,5,10)$ 和 $(2,5,10)$\\n概率 $= \\frac{3}{4}$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2016Q029",
        questionNumber: 29,
        question: "某袋子內有 $1$ 個紅球、$3$ 個黃球及 $6$ 個白球。在一幸運抽獎中，從該袋子內隨機抽出一個球，並將根據下表獲得若干個代幣：\\n所抽出的球的顏色：紅、黃、白\\n所獲代幣的數目：$90$、$20$、$10$\\n求在該幸運抽獎中所獲代幣的數目的期望值。",
        options: [
          { id: "A", text: "$10$" },
          { id: "B", text: "$21$" },
          { id: "C", text: "$40$" },
          { id: "D", text: "$61$" }
        ],
        correctAnswer: "B",
        solution: "期望值 $= 90 \\times \\frac{1}{10} + 20 \\times \\frac{3}{10} + 10 \\times \\frac{6}{10} = 9 + 6 + 6 = 21$",
        topic: "期望值",
        difficulty: "中等"
      },
      {
        id: "2016Q030",
        questionNumber: 30,
        question: "考慮以下數據：\\n$32 \\quad 68 \\quad 79 \\quad 86 \\quad 88 \\quad 98 \\quad 98 \\quad a \\quad b \\quad c$\\n若以上數據的平均值及眾數分別為 $77$ 及 $68$，則以上數據的中位數為",
        options: [
          { id: "A", text: "$76$" },
          { id: "B", text: "$82$" },
          { id: "C", text: "$85$" },
          { id: "D", text: "$93$" }
        ],
        correctAnswer: "B",
        solution: "眾數為 $68$，所以 $a = b = c = 68$\\n平均值 $= 77$\\n$\\frac{32+68+79+86+88+98+98+68+68+68}{10} = 77$\\n中位數 $= \\frac{79+86}{2} = 82.5$",
        topic: "統計",
        difficulty: "中等"
      },
      {
        id: "2016Q031",
        questionNumber: 31,
        question: "$9a^2b$、$12a^4b^3$ 及 $15a^6$ 的 L.C.M. 為",
        options: [
          { id: "A", text: "$3a^2$" },
          { id: "B", text: "$3a^2b$" },
          { id: "C", text: "$180a^6b^3$" },
          { id: "D", text: "$180a^{12}b^4$" }
        ],
        correctAnswer: "C",
        solution: "L.C.M. $= 180a^6b^3$（取各項的最高次方）",
        topic: "L.C.M.",
        difficulty: "基礎"
      },
      {
        id: "2016Q032",
        questionNumber: 32,
        question: "圖中的圖像顯示 $x$ 與 $\\log_9 y$ 之間的線性關係。若 $y = ab^x$，則 $b =$",
        options: [
          { id: "A", text: "$-2$" },
          { id: "B", text: "$\\frac{1}{81}$" },
          { id: "C", text: "$\\frac{1}{2}$" },
          { id: "D", text: "$3$" }
        ],
        correctAnswer: "B",
        solution: "$\\log_9 y = mx + c$\\n$y = 9^{mx+c} = 9^c \\times 9^{mx} = 9^c \\times (9^m)^x$\\n$b = 9^m$\\n從圖像讀取：$m = -2$\\n$b = 9^{-2} = \\frac{1}{81}$",
        topic: "對數",
        difficulty: "困難"
      },
      {
        id: "2016Q033",
        questionNumber: 33,
        question: "$\\text{BC000DE000000}_{16} =$",
        options: [
          { id: "A", text: "$188 \\times 16^{11} + 222 \\times 16^6$" },
          { id: "B", text: "$205 \\times 16^{11} + 239 \\times 16^6$" },
          { id: "C", text: "$188 \\times 16^{12} + 222 \\times 16^7$" },
          { id: "D", text: "$205 \\times 16^{12} + 239 \\times 16^7$" }
        ],
        correctAnswer: "A",
        solution: "$\\text{BC000DE000000}_{16} = \\text{BC}_{16} \\times 16^{11} + \\text{DE}_{16} \\times 16^6$\\n$= 188 \\times 16^{11} + 222 \\times 16^6$",
        topic: "十六進制",
        difficulty: "中等"
      },
      {
        id: "2016Q034",
        questionNumber: 34,
        question: "設 $u = \\frac{7}{a+i}$ 及 $v = \\frac{7}{a-i}$，其中 $a$ 為一實數。下列何者必為正確？\\nI. $uv$ 為一有理數\\nII. $u$ 的實部等於 $v$ 的實部\\nIII. $\\frac{1}{u}$ 的虛部等於 $\\frac{1}{v}$ 的虛部",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "$u = \\frac{7(a-i)}{(a+i)(a-i)} = \\frac{7a-7i}{a^2+1}$\\n$v = \\frac{7(a+i)}{(a-i)(a+i)} = \\frac{7a+7i}{a^2+1}$\\n$uv = \\frac{49}{a^2+1}$（有理數）\\n$\\frac{1}{u} = \\frac{a+i}{7}$，$\\frac{1}{v} = \\frac{a-i}{7}$",
        topic: "複數",
        difficulty: "困難"
      },
      {
        id: "2016Q035",
        questionNumber: 35,
        question: "圖中，$PQ$ 及 $SR$ 均平行於 $x$ 軸。若 $(x,y)$ 為陰影區域 $PQRS$ （包括邊界在內）中的一點，則 $7y - 5x + 3$ 於哪一點達至其最大值？",
        options: [
          { id: "A", text: "$P$" },
          { id: "B", text: "$Q$" },
          { id: "C", text: "$R$" },
          { id: "D", text: "$S$" }
        ],
        correctAnswer: "D",
        solution: "目標函數 $7y - 5x + 3$ 在 $S$ 點達最大值\\n$S$ 點的坐標為 $(0, 12)$\\n最大值 $= 7(12) - 5(0) + 3 = 87$",
        topic: "線性規劃",
        difficulty: "困難"
      },
      {
        id: "2016Q036",
        questionNumber: 36,
        question: "設 $a_n$ 為一等比數列的第 $n$ 項。若 $a_3 = 21$ 及 $a_7 = 189$，則下列何者必為正確？\\nI. 該數列的公比小於 $1$\\nII. 該數列的某些項為無理數\\nIII. 該數列的首 $99$ 項之和大於 $3 \\times 10^{24}$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "B",
        solution: "$a_3 = ar^2 = 21$\\n$a_7 = ar^6 = 189$\\n$r^4 = \\frac{189}{21} = 9$\\n$r = \\sqrt{3}$（大於 $1$）\\n某些項為無理數",
        topic: "等比數列",
        difficulty: "困難"
      },
      {
        id: "2016Q037",
        questionNumber: 37,
        question: "設 $a$ 及 $b$ 均為常數。若圖中所示為 $y = a\\cos 2x°$ 的圖像，則",
        options: [
          { id: "A", text: "$a = -2$ 及 $b = 90$" },
          { id: "B", text: "$a = -2$ 及 $b = 360$" },
          { id: "C", text: "$a = 2$ 及 $b = 90$" },
          { id: "D", text: "$a = 2$ 及 $b = 360$" }
        ],
        correctAnswer: "A",
        solution: "從圖像讀取：振幅 $= 2$，週期 $= 180°$\\n$a = -2$（向下開口）\\n$b = 90°$（四分之一週期）",
        topic: "三角函數",
        difficulty: "中等"
      },
      {
        id: "2016Q038",
        questionNumber: 38,
        question: "當 $0° \\leq \\theta \\leq 360°$ 時，方程 $5\\sin^2 \\theta + \\sin \\theta - 4 = 0$ 有多少個根？",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "C",
        solution: "$5\\sin^2 \\theta + \\sin \\theta - 4 = 0$\\n$(5\\sin \\theta - 4)(\\sin \\theta + 1) = 0$\\n$\\sin \\theta = \\frac{4}{5}$ 或 $\\sin \\theta = -1$\\n$\\sin \\theta = \\frac{4}{5}$ 在 $[0°, 360°)$ 有 $2$ 個根\\n$\\sin \\theta = -1$ 在 $[0°, 360°)$ 有 $1$ 個根\\n總共 $3$ 個根",
        topic: "三角方程",
        difficulty: "中等"
      },
      {
        id: "2016Q039",
        questionNumber: 39,
        question: "圖中，$ABCDEFGH$ 為一長方體。$AC$ 與 $BD$ 相交於 $P$。$Q$ 為 $CH$ 上的一點使得 $CQ = 9$cm 及 $QH = 15$cm。求 $\\sin \\angle PFQ$。",
        options: [
          { id: "A", text: "$\\frac{33}{65}$" },
          { id: "B", text: "$\\frac{56}{65}$" },
          { id: "C", text: "$\\frac{13}{5\\sqrt{181}}$" },
          { id: "D", text: "$\\frac{58}{13\\sqrt{181}}$" }
        ],
        correctAnswer: "A",
        solution: "設長方體邊長為 $a$、$b$、$c$\\n$PF = \\sqrt{a^2 + b^2}$\\n$FQ = \\sqrt{b^2 + c^2}$\\n$PQ = \\sqrt{a^2 + c^2}$\\n用餘弦定理求 $\\cos \\angle PFQ$\\n$\\sin \\angle PFQ = \\frac{33}{65}$",
        topic: "立體三角學",
        difficulty: "困難"
      },
      {
        id: "2016Q040",
        questionNumber: 40,
        question: "圖中，$AC$ 為圓 $ABCD$ 的一直徑。$PB$ 及 $PD$ 均為該圓的切線。$AD$ 的延線與 $BC$ 的延線相交於 $Q$。若 $\\angle BPD = 68°$，則 $\\angle AQB =$",
        options: [
          { id: "A", text: "$22°$" },
          { id: "B", text: "$28°$" },
          { id: "C", text: "$32°$" },
          { id: "D", text: "$34°$" }
        ],
        correctAnswer: "D",
        solution: "$\\angle BPD = 68°$\\n$\\angle BAD = \\angle BCD = 34°$（切線性質）\\n$\\angle AQB = 180° - 34° - 34° = 112°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2016Q041",
        questionNumber: 41,
        question: "直線 $2x - y - 6 = 0$ 與圓 $x^2 + y^2 - 8y - 14 = 0$ 相交於 $P$ 及 $Q$。求 $PQ$ 的中點的 $y$ 坐標。",
        options: [
          { id: "A", text: "$-4$" },
          { id: "B", text: "$-2$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$4$" }
        ],
        correctAnswer: "C",
        solution: "圓心 $(0, 4)$，半徑 $= \\sqrt{16 + 14} = \\sqrt{30}$\\n直線到圓心的距離 $= \\frac{|2(0) - 4 - 6|}{\\sqrt{5}} = \\frac{10}{\\sqrt{5}}$\\n中點的 $y$ 坐標 $= 2$",
        topic: "圓與直線",
        difficulty: "困難"
      },
      {
        id: "2016Q042",
        questionNumber: 42,
        question: "某箱子內有 $9$ 罐咖啡及 $3$ 罐紅茶。若從該箱子中隨機取出 $4$ 罐，求取出至少 $2$ 罐紅茶的概率。",
        options: [
          { id: "A", text: "$\\frac{13}{55}$" },
          { id: "B", text: "$\\frac{21}{55}$" },
          { id: "C", text: "$\\frac{34}{55}$" },
          { id: "D", text: "$\\frac{42}{55}$" }
        ],
        correctAnswer: "A",
        solution: "總組合數 $= C_4^{12} = 495$\\n取出 $2$ 罐紅茶：$C_2^3 \\times C_2^9 = 3 \\times 36 = 108$\\n取出 $3$ 罐紅茶：$C_3^3 \\times C_1^9 = 1 \\times 9 = 9$\\n概率 $= \\frac{108 + 9}{495} = \\frac{117}{495} = \\frac{13}{55}$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2016Q043",
        questionNumber: 43,
        question: "某班有 $20$ 名男生及 $15$ 名女生。若從該班中選出 $6$ 名學生組成一個至多有 $2$ 名女生的委員會，則可組成多少個不同的委員會？",
        options: [
          { id: "A", text: "$271320$" },
          { id: "B", text: "$324415$" },
          { id: "C", text: "$508725$" },
          { id: "D", text: "$780045$" }
        ],
        correctAnswer: "A",
        solution: "至多有 $2$ 名女生：\\n$0$ 名女生：$C_6^{20} = 38760$\\n$1$ 名女生：$C_5^{20} \\times C_1^{15} = 15504 \\times 15 = 232560$\\n$2$ 名女生：$C_4^{20} \\times C_2^{15} = 4845 \\times 105 = 508725$\\n總數 $= 38760 + 232560 + 508725 = 780045$",
        topic: "排列組合",
        difficulty: "困難"
      },
      {
        id: "2016Q044",
        questionNumber: 44,
        question: "下面的幹葉圖顯示某群學生在一測驗中得分（以分為單位）的分佈。佩玲在該測驗中獲最高得分。\\n下列何者正確？\\nI. 該分佈的上四分位數為 $55$ 分\\nII. 佩玲在該測驗中的標準分低於 $2$\\nIII. 該分佈的標準差大於 $12$ 分",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "D",
        solution: "從幹葉圖讀取數據\\nI. 上四分位數不是 $55$ 分\\nII. 佩玲得分最高，標準分低於 $2$\\nIII. 標準差大於 $12$ 分",
        topic: "統計",
        difficulty: "困難"
      },
      {
        id: "2016Q045",
        questionNumber: 45,
        question: "某組數的方差為 $49$。將該組的每個數乘以 $4$ 後各加上 $9$ 而成新一組數。求新一組數的方差。",
        options: [
          { id: "A", text: "$196$" },
          { id: "B", text: "$205$" },
          { id: "C", text: "$784$" },
          { id: "D", text: "$793$" }
        ],
        correctAnswer: "C",
        solution: "新數據 $= 4x + 9$\\n新方差 $= 4^2 \\times 49 = 16 \\times 49 = 784$",
        topic: "統計",
        difficulty: "中等"
      }
    ],
    topics: [
      "指數",
      "因式分解",
      "恆等式",
      "二次方程", 
      "二次函數",
      "不等式",
      "函數",
      "對數",
      "三角函數",
      "三角方程",
      "立體幾何",
      "圓",
      "圓與直線",
      "排列組合",
      "統計"
    ],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };